        
        const passwordGate = document.getElementById('password-gate');
        const mainContent = document.getElementById('main-content');
        const passwordInput = document.getElementById('password-input');
        const passwordMessage = document.getElementById('password-message');
        const submitBtn = document.getElementById('submit-password-btn');
        const correctPassword = "121212";
        function checkPassword() {
            if (passwordInput.value === correctPassword) {
                setCookie('india_login', 'true', 1);
                window.location = 'https://customplaquesin.com/';
            } else {
                passwordMessage.textContent = 'Incorrect password. Please try again.';
                passwordInput.value = '';
            }
        }      
        submitBtn.addEventListener('click', function(event) {
            event.preventDefault();
            checkPassword();
        });
        
        passwordInput.addEventListener('keypress', function(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                checkPassword();
            }
        });

        function setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString()
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/"
        }